import { jsx } from 'react/jsx-runtime';

const SvgStatusPlaying = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M5 20.37 19.5 12 5 3.63v16.74ZM7 7.09 15.5 12 7 16.91V7.09Z" }) }));

export { SvgStatusPlaying as default };
//# sourceMappingURL=StatusPlaying.es.js.map
